<div class="breadcrumbs-container" [ngClass]="{ 'is-zoomed': isZoomed }">
  <motif-icon
    [iconFunction]="IconoirHome"
    class="home-icon"
    role="button"
    (click)="navigateTo(home)"
    (keydown.enter)="navigateTo(home)"
    style="color: #a4a6b8"
    [tabIndex]="0"
    aria-label="Navigate to Home page"
    aria-live="polite"
  ></motif-icon>
  <span aria-hidden="true">|</span>

  @for (tab of breadcrumbTabs; track $index) {
  <p
    class="breadcrumb"
    [tabIndex]="conditionForTabAccess(tab)"
    (click)="navigateTo(tab.route)"
    (keydown.enter)="navigateTo(tab.route)"
    [ngClass]="{ active: tab.active }"
  >
    {{ tab.name }}
  </p>
  <motif-icon
    [iconFunction]="IconoirNavArrowRight"
    *ngIf="$index + 1 !== breadcrumbTabs.length"
    aria-hidden="true"
  ></motif-icon>
  }
</div>
